import React, { createContext, useContext } from 'react'

/**
 * CalculatorContext
 * Shared state for all Calculator sub-components.
 * Wrap the Calculator render with <CalculatorProvider value={...}>
 */
export const CalculatorContext = createContext(null)

export const useCalculator = () => {
  const ctx = useContext(CalculatorContext)
  if (!ctx) throw new Error('useCalculator must be used inside CalculatorProvider')
  return ctx
}

export const CalculatorProvider = ({ children, value }) => (
  <CalculatorContext.Provider value={value}>
    {children}
  </CalculatorContext.Provider>
)
